import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ProtectedRoute } from "./components/ProtectedRoute";
import {
  ThemeProvider,
  NotificationProvider,
  ModalProvider,
  SearchProvider,
  GeolocationProvider,
  OnboardingProvider,
  FeatureFlagsProvider,
} from "./contexts";
import { Web3Provider } from "./contexts/Web3Provider";
import { useAuth } from "./hooks/useAuth";
import { protectedRoutes, publicRoutes } from "./lib/navigation";
import NotFound from "./pages/NotFound";
import CityLanding from "./pages/CityLanding";

function Router() {
  // This hook syncs user to Convex on sign in
  useAuth();

  return (
    <Switch>
      {/* Public routes - anyone can access */}
      {publicRoutes.map((route) => (
        <Route key={route.path} path={route.path} component={route.component} />
      ))}

      {/* Protected routes - require authentication */}
      {protectedRoutes.map((route) => {
        const Component = route.component;
        return (
          <Route key={route.path} path={route.path}>
            <ProtectedRoute><Component /></ProtectedRoute>
          </Route>
        );
      })}

      <Route path={"/404"} component={NotFound} />

      {/* SEO City Landing Pages */}
      <Route path="/personals/:country/:city" component={() => {
        // Lazy load or import at top? import at top is safer for now
        return <CityLanding />;
      }} />

      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <Web3Provider>
          <FeatureFlagsProvider>
            <NotificationProvider>
              <ModalProvider>
                <SearchProvider>
                  <GeolocationProvider>
                    <OnboardingProvider>
                      <TooltipProvider>
                        <Toaster />
                        <Router />
                      </TooltipProvider>
                    </OnboardingProvider>
                  </GeolocationProvider>
                </SearchProvider>
              </ModalProvider>
            </NotificationProvider>
          </FeatureFlagsProvider>
        </Web3Provider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
